"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

type Intensity = "full" | "subtle" | "muted"

const FULL_PATHS = new Set([
  "/",
  "/sign-in",
  "/sign-up",
  "/otp",
  "/profile-setup",
  "/tutorial",
  "/forgot-password",
])

const MUTED_PREFIXES = ["/booking/confirmed", "/check-in"]

function intensityFor(pathname: string): Intensity {
  if (FULL_PATHS.has(pathname)) return "full"
  if (MUTED_PREFIXES.some((p) => pathname.startsWith(p))) return "muted"
  return "subtle"
}

/**
 * Writes `data-backdrop` on <html> after hydration so the BrandBackdrop can
 * adjust its intensity per route via CSS variables. Lives outside <PageTransition>
 * so the attribute change isn't snapshotted into a view transition.
 */
export function BackdropIntensitySwitcher() {
  const pathname = usePathname()

  useEffect(() => {
    document.documentElement.dataset.backdrop = intensityFor(pathname)
  }, [pathname])

  return null
}
